// Safe logger initialization pattern
window.mcb = window.mcb || {};
window.mcb.utilities = window.mcb.utilities || {};

// Create a fallback logger that just uses console
const createFallbackLogger = function () {
    return {
        log: console.log.bind(console),
        warn: console.warn.bind(console),
        error: console.error.bind(console),
        trace: console.debug.bind(console)
    };
};

// Safe logger factory that ensures dependencies exist
window.mcb.utilities.createLogger = function (namespace, prettyName = null) {
    // Check dependencies
    if (!window.mcb?.utilities?.debug?.isDebuggingArea) {
        console.warn('Logger dependencies not initialized, using fallback logger');
        return createFallbackLogger();
    }

    // Create actual logger instance if dependencies exist
    return new window.mcb.utilities.logger(namespace, prettyName);
};
